module.exports = __webpack_public_path__ + "static/media/confirmGreen.1e5caf4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/img/confirmGreen.svg
// module id = 118
// module chunks = 0